const applicationsPagePath = '/applications';
const modelsPagePath = '/models';
const dataPagePath = '/data/:tabId';

// New navigation
const modelApisPagePath = '/model-apis';
const chainsPagePath = '/chains';
const trainingPagePath = '/training';
const overviewPagePath = '/overview';
// navigation with teams
const teamModelsPagePath = '/teams/:teamId/models';
const teamChainsPagePath = '/teams/:teamId/chains';
const teamTrainingPagePath = '/teams/:teamId/training';
const teamModelApisPagePath = '/teams/:teamId/model-apis';
const teamSettingsPagePath = '/teams/:teamId/settings/:tabId?';

export {
  applicationsPagePath,
  dataPagePath,
  modelApisPagePath,
  chainsPagePath,
  trainingPagePath,
  overviewPagePath,
  modelsPagePath,
  // teams
  teamModelsPagePath,
  teamChainsPagePath,
  teamTrainingPagePath,
  teamModelApisPagePath,
  teamSettingsPagePath,
};
